import { defineComponent as _defineComponent } from 'vue'
interface Props {
  placement?:
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'top-start'
    | 'top-end'
    | 'bottom-start'
    | 'bottom-end'
    | 'left-start'
    | 'left-end'
    | 'right-start'
    | 'right-end'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpTooltip',
  props: {
    placement: { default: 'top' }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})